/** Экземпляр карты по id; отсутствие — ошибка с контекстом. */
export function requireInstance(state, instanceId, where) {
    const inst = state.instances[instanceId];
    if (inst === undefined) {
        throw new Error(`${where}: неизвестный экземпляр "${instanceId}"`);
    }
    return inst;
}
/** Игрок по id; отсутствие — ошибка с контекстом. */
export function requirePlayer(state, playerId, where) {
    const player = state.players[playerId];
    if (player === undefined) {
        throw new Error(`${where}: неизвестный игрок "${playerId}" (игроки: ${Object.keys(state.players).join(', ')})`);
    }
    return player;
}
/** Ячейка по id; отсутствие — ошибка с контекстом. */
export function requireCell(state, cellId, where) {
    const cell = state.board.cells[cellId];
    if (cell === undefined) {
        throw new Error(`${where}: неизвестная ячейка "${cellId}" (канон: "T{0..2}-L{0..2}-{A|B}")`);
    }
    return cell;
}
//# sourceMappingURL=access.js.map